module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/05-27c6d6079e4057e14733a60ca82676b5.jpg";